document.addEventListener('DOMContentLoaded', function () {
  const monkeybars = document.getElementById('monkey-bars');
  const trampolines = document.getElementById('trampolines');
  const swings = document.getElementById('swings-playsets');

  setTimeout(function () {
    monkeybars.style.opacity = 1;
    monkeybars.style.display = 'none';
    trampolines.style.opacity = 1;
    trampolines.style.display = 'none';
    swings.style.opacity = 1;
    swings.style.display = 'none';
  }, 500);
});
